module.exports = __webpack_public_path__ + "344d723e65c490a807edd8e8fda276d0.MP3";